module.exports = __webpack_public_path__ + "static/media/hspreview.5fd5670c.png";